import { Link } from "react-router-dom";
import "./NavItem.css";
import { LucideIcon } from "lucide-react";

interface Props {
  destination: string;
  icon: LucideIcon;
  label: string;
}

function NavItem({ destination, icon: Icon, label }: Props) {
  return (
    <Link to={destination} className="nav-item">
      <div className="nav-circle">
        <Icon size={75} />
      </div>
      <span className="nav-label">{label}</span>
    </Link>
  );
}

export default NavItem;
